import React from 'react';
import Wrapper from './styles';

import { filterStyleProps } from '../../styles/utils';

interface Props {
    icon: string;
    alt?: string;
    large?: boolean;
    className?: string;
}

export default function Icon({ icon, alt, ...rest }: Props) {
    const iconPath = `/assets/images/sport-icons/${icon}.png`;
    return <Wrapper {...filterStyleProps({ ...rest })} src={iconPath} alt={alt || ''} />;
}
